import { businessInfo, SITE_URL } from '../config/seoConfig';

export const generateLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${SITE_URL}/#organization`,
  name: businessInfo.name,
  legalName: businessInfo.legalName,
  description: businessInfo.description,
  url: SITE_URL,
  telephone: businessInfo.telephone,
  email: businessInfo.email,
  image: businessInfo.image,
  address: {
    '@type': 'PostalAddress',
    streetAddress: businessInfo.address.streetAddress,
    addressLocality: businessInfo.address.addressLocality,
    addressRegion: businessInfo.address.addressRegion,
    postalCode: businessInfo.address.postalCode,
    addressCountry: businessInfo.address.addressCountry,
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: businessInfo.geo.latitude,
    longitude: businessInfo.geo.longitude,
  },
  priceRange: businessInfo.priceRange,
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    opens: '09:00',
    closes: '18:00',
  },
  sameAs: businessInfo.sameAs,
});
